export default __webpack_public_path__ + "static/media/arrow-right-moon-gray.93217cdf.svg";